import { SAMLAuthProvider } from 'firebase/auth';

export const getSamlProvider = (providerId: string) => {
  return new SAMLAuthProvider(providerId);
};
